export default __webpack_public_path__ + "static/media/vacation_lg.6eadc6ed.jpg";